'use client'

import { useTranslations } from 'next-intl'

import { ContentForm } from '../../ContentForm'
import {
	qrNameFormConfig,
	TQrContentFormSection,
} from '../../contentFormSections'
import { websiteUrlFormConfig } from '../../contentFormSections/WebsiteUrlForm'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const WebsiteUrlContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			websiteUrlFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.Url} config={config} {...props} />
}
